import { useInject } from 'dependable-react';
import { css } from 'emotion';
import React, { useContext, useEffect, useState } from 'react';
import { APP_DATA_TOKEN } from '../../services/InjectTokens';
import { BookContext } from '../Book';
import { PageLoader } from '../PageContent/components/PageLoader';

const pageStyles = (pageDimensions: any) => css`
  position: relative;
  display: inline-block;
  background: #f4f4f7;
  width: ${pageDimensions.width}mm;
  height: ${pageDimensions.height}mm;

  transition: transform 0.8s ease, z-index 0.1ms 0.2s ease;
  transform-style: preserve-3d;
  transform-origin: 0;
  -webkit-tap-highlight-color: transparent;
  overflow: hidden;
`;

const coverInner = css`
  width: 50%;
  height: 100%;
  overflow: hidden;
`;

export const MobilePage = ({ page, children, ...rest }: any) => {
  const ctx: any = useContext(BookContext);
  const appState = useInject(APP_DATA_TOKEN);
  const [totalImages, setTotalImages] = useState(0);
  const [loadedImages, setLoadedImages] = useState(0);
  const [initialLoaded, setInitialLoaded] = useState(false);

  useEffect(() => {
    setLoadedImages(0);
    const pageContent = document.getElementById(`page-${page}-content`);

    let images: Array<HTMLImageElement>;
    if (pageContent) {
      images = [...Array.from(pageContent.getElementsByTagName('img'))];
      setTotalImages(images.length);
      images.forEach((image) => {
        image.addEventListener('load', () => {
          setLoadedImages((prevState) => prevState + 1);
        });
      });
    }
  }, [appState.avatars, appState.currentLanguage]);

  useEffect(() => {
    if (loadedImages === totalImages && loadedImages !== 0 && totalImages !== 0) {
      setInitialLoaded(true);
    }
  }, [loadedImages, totalImages]);

  return (
    <div className={pageStyles(ctx.pageDimensions)} {...rest}>
      {!initialLoaded && <PageLoader />}
      {children}
    </div>
  );
};

export const CoverPage = ({ children, ...rest }: any) => {
  const ctx: any = useContext(BookContext);

  return (
    <MobilePage pageDimensions={ctx.pageDimensions} {...rest}>
      <div
        className={coverInner}
        style={{
          width: `${ctx.coverDimensions.width}mm`,
          height: `${ctx.coverDimensions.height}mm`,
          transform: `scaleX(0.895) scaleY(0.903) translateY(-70px) translateX(-105px)`,
        }}
      >
        {children}
      </div>
    </MobilePage>
  );
};
